import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonGroup } from 'react-bootstrap';

import { Document, Page } from 'react-pdf';
import './Pdf.css';

import { pdfjs } from 'react-pdf';
import { BsArrowRight, BsArrowLeft, BsFileEarmark } from 'react-icons/all';

import { FaFilePdf } from 'react-icons/fa';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const highlightPattern = (text, pattern) => {
  //const regex = new RegExp(pattern, 'i');
  //const splitText = text.split(regex);

  const splitText = text.split(pattern);

  if (splitText.length <= 1) {
    return text;
  }

  const matches = text.match(pattern);

  return splitText.reduce(
    (arr, element, index) =>
      matches[index]
        ? [...arr, element, <mark key={index}>{matches[index]}</mark>]
        : [...arr, element],
    []
  );
};

const RectOverlay = ({ overlays, width, height, pageNumber }) => {
  if (!width) {
    return null;
  }

  return (
    <svg
      style={{ position: 'absolute', top: '0px' }}
      width={width}
      height={height}
    >
      {overlays
        .filter((overlay) => +overlay.page === pageNumber)
        .map((overlay, i) => (
          <rect
            x={0}
            width={width}
            y={(height * overlay['top']) / overlay['page-height']}
            height={
              (height * (overlay['bottom'] - overlay['top'])) /
              overlay['page-height']
            }
            fill="gold"
            stroke="black"
            strokeWidth="2px"
            opacity="0.2"
            key={i}
          />
        ))}
      ;
    </svg>
  );
};

RectOverlay.propTypes = {
  overlays: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.string,
      top: PropTypes.string,
      bottom: PropTypes.string,
      'page-height': PropTypes.string
    })
  ),
  pageNumber: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number
};

const Pdf = ({
  url,
  searchString,
  overlays,
  pageNumber,
  setPageNumber,
  pageWidth
}) => {
  const [numPages, setNumPages] = useState(1);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const onDocumentLoadSuccess = (document) => {
    setNumPages(document.numPages);
  };

  const makeTextRenderer = (searchText) => (textItem) =>
    highlightPattern(textItem.str, searchText);

  const saveSize = (ref) => {
    if (ref) {
      const canvas = document.getElementsByClassName('react-pdf__Page')[0]
        .children[0];
      console.log(`Setting size to: ${canvas.width}, ${canvas.height}`);
      setHeight(parseInt(canvas.style.height));
      setWidth(parseInt(canvas.style.width));
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          margin: '25px auto auto',
          width: `${pageWidth}px`,
          position: 'relative'
        }}
      >
        <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
          <Page
            width={pageWidth}
            inputRef={saveSize}
            pageNumber={pageNumber || 1}
            customTextRenderer={makeTextRenderer(searchString)}
            renderAnnotationLayer={false}
          />
        </Document>
        {overlays && (
          <RectOverlay
            width={width}
            height={height}
            overlays={overlays}
            pageNumber={pageNumber}
          />
        )}
      </div>

      <div
        id={'all-buttons'}
        style={{ position: 'absolute', width: '100%', top: '0px' }}
      >
        <div style={{ position: 'absolute', left: '50%' }}>
          <div
            style={{
              width: 'max-content'
            }}
          >
            <ButtonGroup size="sm" style={{ left: '-50%' }}>
              <Button
                variant={'secondary'}
                disabled={pageNumber <= 1}
                onClick={() => setPageNumber(pageNumber - 1)}
                title={'Previous page'}
              >
                <BsArrowLeft />
                <BsFileEarmark />
              </Button>

              <Button disabled={true} variant={'secondary'}>
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="open-pdf-file-from-preview"
                >
                  <FaFilePdf
                    color={'black'}
                    title={'Open PDF file in new tab'}
                  />
                </a>{' '}
                Page {pageNumber || (numPages ? 1 : '--')} / {numPages || '--'}
              </Button>

              <Button
                variant={'secondary'}
                disabled={pageNumber >= numPages}
                onClick={() => setPageNumber(pageNumber + 1)}
                title={'Next page'}
              >
                <BsFileEarmark />
                <BsArrowRight />
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Pdf.propTypes = {
  url: PropTypes.string,
  searchString: PropTypes.string,
  overlays: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.string,
      top: PropTypes.string,
      bottom: PropTypes.string,
      'page-height': PropTypes.string
    })
  ),
  pageNumber: PropTypes.number,
  setPageNumber: PropTypes.func,
  pageWidth: PropTypes.number.isRequired
};

export default Pdf;
